// import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import GreetingSection from '../../components/navbar/GreetingSection';
import { Row, Col } from 'antd';
import { PolicyList } from './components';
import './myPolicy.less';
const PoliciesPageContainer = styled.div`
  margin: 0;
  dispay: flex;
`;
const PoliciesPage = () => {
  const { t } = useTranslation();
  return (
    <PoliciesPageContainer>
      <GreetingSection pageName={t('life.policies.title')} showicon={true} />
      <Row gutter={[{ xs: 8, sm: 24, lg: 24 }, 16]} wrap className="policy-list-row">
        <Col xs={{ span: 24 }} sm={{ span: 23 }} lg={{ span: 24 }}>
          <PolicyList></PolicyList>
        </Col>
      </Row>
    </PoliciesPageContainer>
  );
};

export default PoliciesPage;
